angular.module("app").directive('chosenForMultiple', function() {
    return {
        //scope: true,   // optionally create a child scope
        restrict: "A",
        link: function (scope, element, attrs) {
            var chosen = $(element).chosen().data("chosen");
            var autoClose = false;
            var chosen_resultSelect_fn = chosen.result_select;
            chosen.result_select = function(evt) {
                var resultHighlight = null;

                if(autoClose == false)
                {
                    evt["metaKey"] = true;
                    evt["ctrlKey"] = true;

                    resultHighlight = chosen.result_highlight;
                }

                var result = chosen_resultSelect_fn.call(chosen, evt);

                if(autoClose == false && resultHighlight != null)
                    resultHighlight.addClass("result-selected");

                return result;
            };
        }
    };
});